<template>
  <default-layout>
    <section slot="content">
      <template>
        <div>
          <template>
            <v-row justify="center">
              <v-col cols="12" md="12" xs="12">
                <v-expansion-panels multiple v-model="panel">

                  <v-expansion-panel>
                    <v-expansion-panel-header class="tile">
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <b>Filtrar Producto(s)</b>
                      </v-col>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>

                      <v-card flat>
                        <v-card-text>
                          <template>
                            <v-form ref="searchProduct" v-model="valid">
                              <v-container>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="8"
                                  >
                                    <v-dialog
                                      ref="dialog"
                                      v-model="modal"
                                      :return-value.sync="date"
                                      persistent
                                      width="290px"
                                    >
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                          v-model="dateRangeText"
                                          label="Rango Fechas de Creación"
                                          prepend-icon="mdi-calendar"
                                          readonly
                                          v-bind="attrs"
                                          v-on="on"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker
                                        v-model="dates"
                                        scrollable
                                        range
                                        locale="es"
                                        :max="date"
                                        selected-items-text="seleccionados"
                                      >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          text
                                          color="primary"
                                          @click="modal = false"
                                        >
                                          Cancel
                                        </v-btn>
                                        <v-btn
                                          text
                                          color="primary"
                                          @click="$refs.dialog.save(date)"
                                        >
                                          OK
                                        </v-btn>
                                      </v-date-picker>
                                    </v-dialog>
                                  </v-col>

                                  <v-col
                                    cols="12"
                                    md="2"
                                  >
                                    <v-btn
                                      color="primary"
                                      block
                                      depressed
                                      @click="getProducts()"
                                    >
                                      <v-icon dark>
                                        manage_search
                                      </v-icon>
                                    </v-btn>
                                  </v-col>

                                  <v-col
                                    cols="12"
                                    md="2"
                                  >
                                    <v-btn
                                      color="green"
                                      block
                                      depressed
                                      @click="domwloadExcel()"
                                    >
                                      <v-icon dark>
                                        file_download
                                      </v-icon>
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-form>
                          </template>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel>
                    <v-expansion-panel-header class="tile">
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <b>Registro de Productos</b>
                      </v-col>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row dense align="center" justify="center">
                        <v-col cols="12">
                          <v-card flat>
                            <v-card-title>
                              <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Ingresar texto a buscar"
                                single-line
                                hide-details
                              ></v-text-field>
                            </v-card-title>
                            <v-data-table
                              :headers="headers"
                              :items="items"
                              :search="search"
                            >
                              <template v-slot:item.created_at="{ item }">
                                {{ formatDateTime(item.created_at) }}
                              </template>

                              <template v-slot:item.delivery_day="{ item }">
                                {{ formatDate(item.delivery_day) }}
                              </template>

                              <template v-slot:item.status="{ item }">
                                <v-chip
                                  :color="getColorOrTextStatus(item.status, 'color')"
                                  dark
                                >
                                  {{ getColorOrTextStatus(item.status, 'text')  }}
                                </v-chip>
                              </template>

                              <template v-slot:item.actions="{ item }">
                                <v-row
                                  align="center"
                                  class="spacer"
                                  no-gutters
                                >
                                  <v-btn
                                    depressed
                                    color="primary"
                                    @click="getDetail(item)"
                                    class="ma-2"
                                  >
                                    <v-icon dark>
                                      visibility
                                    </v-icon>
                                  </v-btn>
                                  <v-btn
                                    depressed
                                    color="primary"
                                    @click="copy(item)"
                                    class="ma-2"
                                  >
                                    <v-icon dark>
                                      content_copy
                                    </v-icon>
                                  </v-btn>
                                </v-row>
                              </template>
                            </v-data-table>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>

              <v-dialog
                v-model="dialog"
                lg
              >
                <v-card>
                  <v-card-title class="primary dark">
                    <template>
                      <v-tabs
                          v-model="tab"
                          background-color="primary"
                          dark
                      >
                        <v-tab href="#tab-1">Pedidos de Productos (Proveedor)</v-tab>
                      </v-tabs>
                    </template>
                  </v-card-title>

                  <v-card-text>
                    <v-tabs-items v-model="tab">
                      <v-tab-item
                        key="1"
                        value="tab-1"
                      >
                        <v-card flat>
                          <v-card-text>
                            <template>
                              <v-form ref="form" v-model="validForm" :disabled="orderSupplier.id ? true : false">
                                <v-container fluid>
                                  <v-row justify="center">
                                    <v-expansion-panels v-model="panelOrder" popout multiple>
                                      <v-expansion-panel key="orderSupplier" hide-actions>
                                        <v-expansion-panel-header>
                                          <v-row
                                            align="center"
                                            class="spacer"
                                            no-gutters
                                          >
                                            <v-col
                                              cols="4"
                                              sm="2"
                                              md="1"
                                            >
                                              <v-avatar size="36px">
                                                <v-icon color="red">storefront</v-icon>
                                              </v-avatar>
                                            </v-col>

                                            <v-col
                                              class="hidden-xs-only"
                                              sm="5"
                                              md="3"
                                            >
                                              <strong>DATOS DE LA COMPRA</strong>
                                            </v-col>
                                          </v-row>
                                        </v-expansion-panel-header>

                                        <v-expansion-panel-content>
                                          <v-divider></v-divider>
                                          <v-card-text>
                                            <v-container>
                                              <v-row>
                                                <v-col
                                                  cols="12"
                                                  md="6"
                                                >
                                                  <v-text-field
                                                    v-model="orderSupplier.supplier_name"
                                                    label="Nombre del Proveedor"
                                                    outlined
                                                    dense
                                                  ></v-text-field>
                                                </v-col>

                                                <v-col
                                                  cols="12"
                                                  md="4"
                                                >
                                                  <v-dialog
                                                    ref="dialog"
                                                    v-model="modalDeliveryDay"
                                                    :return-value.sync="date"
                                                    persistent
                                                    width="290px"
                                                  >
                                                    <template v-slot:activator="{ on, attrs }">
                                                      <v-text-field
                                                        v-model="dateText"
                                                        label="Fecha de Entrega o Recojo"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        outlined
                                                        dense
                                                      ></v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                      v-model="date"
                                                      scrollable
                                                    >
                                                      <v-spacer></v-spacer>
                                                      <v-btn
                                                        text
                                                        color="primary"
                                                        @click="modalDeliveryDay = false"
                                                      >
                                                        Cancel
                                                      </v-btn>
                                                      <v-btn
                                                        text
                                                        color="primary"
                                                        @click="$refs.dialog.save(date)"
                                                      >
                                                        OK
                                                      </v-btn>
                                                    </v-date-picker>
                                                  </v-dialog>
                                                </v-col>

                                                <v-col
                                                  cols="12"
                                                  md="2"
                                                >
                                                  <v-text-field
                                                    v-model="orderSupplier.quantity"
                                                    label="Cantidad de Productos Pedidos"
                                                    outlined
                                                    dense
                                                    disabled
                                                  ></v-text-field>
                                                </v-col>
                                              </v-row>
                                            </v-container>
                                          </v-card-text>
                                        </v-expansion-panel-content>
                                      </v-expansion-panel>

                                      <v-expansion-panel key="addProduct" hide-actions>
                                        <v-expansion-panel-header>
                                          <v-row
                                            align="center"
                                            class="spacer"
                                            no-gutters
                                          >
                                            <v-col
                                              cols="4"
                                              sm="2"
                                              md="1"
                                            >
                                              <v-avatar size="36px">
                                                <v-icon color="red">assistant_direction</v-icon>
                                              </v-avatar>
                                            </v-col>

                                            <v-col
                                              class="hidden-xs-only"
                                              sm="5"
                                              md="3"
                                            >
                                              <strong>AGREGAR PRODUCTOS AL DETALLE</strong>
                                            </v-col>
                                          </v-row>
                                        </v-expansion-panel-header>

                                        <v-expansion-panel-content>
                                          <v-divider></v-divider>
                                          <v-card-text>
                                            <v-container>
                                              <v-row>
                                                <v-col
                                                  cols="12"
                                                  md="12"
                                                >
                                                  <v-select
                                                    v-model="selected.product"
                                                    :items="select.products"
                                                    item-value="id"
                                                    item-text="name"
                                                    label="Productos"
                                                    :rules="[rules.required]"
                                                    dense
                                                    outlined
                                                  >
                                                    <template v-slot:prepend-item>
                                                      <v-list-item>
                                                        <v-list-item-content>
                                                          <v-text-field
                                                            v-model="searchProduct"
                                                            placeholder="Buscar"
                                                            @input="searchArticulos"
                                                            dense
                                                            outlined
                                                          ></v-text-field>
                                                        </v-list-item-content>
                                                      </v-list-item>
                                                      <v-divider class="mt-2"></v-divider>
                                                    </template>
                                                  </v-select>
                                                </v-col>
                                                <v-col
                                                  cols="12"
                                                  md="3"
                                                >
                                                  <v-select
                                                    v-model="selected.productColor"
                                                    :items="select.productColors"
                                                    item-value="id"
                                                    item-text="color.name"
                                                    label="Colores"
                                                    :rules="[rules.required]"
                                                    dense
                                                    outlined
                                                  ></v-select>
                                                </v-col>
                                                <v-col
                                                  cols="12"
                                                  md="3"
                                                >
                                                  <v-select
                                                    v-model="selected.productColorSize"
                                                    :items="select.productColorSizes"
                                                    item-value="id"
                                                    item-text="size.name"
                                                    label="Tallas"
                                                    :rules="[rules.required]"
                                                    dense
                                                    outlined
                                                  ></v-select>
                                                </v-col>
                                                <v-col
                                                  cols="12"
                                                  md="2"
                                                >
                                                  <v-text-field
                                                    v-model="quantity"
                                                    label="Cantidad"
                                                    outlined
                                                    dense
                                                  ></v-text-field>
                                                </v-col>
                                                <v-col
                                                  cols="12"
                                                  md="2"
                                                >
                                                  <v-text-field
                                                    v-model="unit_price"
                                                    label="Precio Unitario"
                                                    outlined
                                                    dense
                                                  ></v-text-field>
                                                </v-col>
                                                <v-col
                                                  cols="12"
                                                  md="2"
                                                >
                                                  <v-btn
                                                    v-if="!orderSupplier.id"
                                                    :readonly="!valid"
                                                    color="primary"
                                                    block
                                                    depressed
                                                    @click="addProduct"
                                                  >
                                                    <v-icon dark>mdi-plus</v-icon>
                                                  </v-btn>
                                                </v-col>
                                              </v-row>
                                            </v-container>
                                          </v-card-text>
                                        </v-expansion-panel-content>
                                      </v-expansion-panel>

                                      <v-expansion-panel key="orderSupplierDetail" hide-actions>
                                        <v-expansion-panel-header>
                                          <v-row
                                            align="center"
                                            class="spacer"
                                            no-gutters
                                          >
                                            <v-col
                                              cols="4"
                                              sm="2"
                                              md="1"
                                            >
                                              <v-avatar size="36px">
                                                <v-icon color="red">assistant_direction</v-icon>
                                              </v-avatar>
                                            </v-col>

                                            <v-col
                                              class="hidden-xs-only"
                                              sm="5"
                                              md="3"
                                            >
                                              <strong>DETALLE DE COMPRA</strong>
                                            </v-col>
                                          </v-row>
                                        </v-expansion-panel-header>

                                        <v-expansion-panel-content>
                                          <v-divider></v-divider>
                                          <v-card-text>
                                            <v-container>
                                              <v-row>
                                                <v-col cols="12">
                                                  <v-data-table
                                                    :headers="OSHeaders"
                                                    :items="OSItems"
                                                  >
                                                    <template v-slot:item.accion="{ item, index }">
                                                      <v-btn
                                                        depressed
                                                        color="primary"
                                                        @click="removeRow(index, item)"
                                                        :disabled="orderSupplier.id ? true : false"
                                                      >
                                                        <v-icon dark>
                                                          delete
                                                        </v-icon>
                                                      </v-btn>
                                                    </template>
                                                  </v-data-table>
                                                </v-col>
                                                <v-col
                                                  cols="12"
                                                  md="3"
                                                  offset-md="9"
                                                >
                                                  <v-text-field
                                                    v-model="orderSupplier.shipping_price"
                                                    label="Costo del Recojo o Delivery"
                                                    outlined
                                                    dense
                                                  ></v-text-field>
                                                </v-col>
                                                <v-col
                                                  cols="12"
                                                  md="3"
                                                  offset-md="9"
                                                  class="mt-n10"
                                                >
                                                  <v-text-field
                                                    v-model="orderSupplier.subtotal"
                                                    label="Subtotal"
                                                    outlined
                                                    dense
                                                    disabled
                                                  ></v-text-field>
                                                </v-col>

                                                <v-col
                                                  cols="12"
                                                  md="3"
                                                  offset-md="9"
                                                  class="mt-n10"
                                                >
                                                  <v-text-field
                                                    v-model="orderSupplier.total"
                                                    label="Total"
                                                    outlined
                                                    dense
                                                    disabled
                                                  ></v-text-field>
                                                </v-col>
                                              </v-row>
                                            </v-container>
                                          </v-card-text>
                                        </v-expansion-panel-content>
                                      </v-expansion-panel>
                                    </v-expansion-panels>

                                    <template v-if="!orderSupplier.id">
                                      <v-col
                                        cols="12"
                                        md="4"
                                        offset-md="8"
                                      >
                                        <v-btn
                                          :disabled="disabledBtnSave"
                                          color="primary"
                                          block
                                          depressed
                                          @click="saveOrderSupplier()"
                                        >
                                          REGISTRAR COMPRA
                                        </v-btn>
                                      </v-col>
                                    </template>
                                    <template v-else>
                                      <v-col
                                        cols="12"
                                        md="2"
                                        offset-md="8"
                                      >
                                        <v-btn
                                          style="color: white"
                                          color="red"
                                          block
                                          depressed
                                          :disabled="orderSupplier.status == 2 || orderSupplier.status == 0"
                                          @click="updateStatusOrderSupplier(orderSupplier.id, 0)"
                                        >
                                          ANULAR
                                        </v-btn>
                                      </v-col>
                                      <v-col
                                        cols="12"
                                        md="2"
                                      >
                                        <v-btn
                                          style="color: white"
                                          color="green"
                                          block
                                          depressed
                                          :disabled="orderSupplier.status == 2 || orderSupplier.status == 0"
                                          @click="updateStatusOrderSupplier(orderSupplier.id, 2)"
                                        >
                                          RECEPCIONADO
                                        </v-btn>
                                      </v-col>
                                    </template>
                                  </v-row>
                                </v-container>
                              </v-form>
                            </template>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="adm_orange"
                      text
                      @click="dialog = false"
                    >
                      Cerrar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

            </v-row>
          </template>

          <v-btn
            fab
            bottom
            right
            color="primary"
            dark
            fixed
            @click="dialog = true"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </div>
      </template>

      <template>
        <div class="text-center ma-2">
          <v-snackbar
            v-model="snackbar"
            :color="color"
            top
            z-index="500"
          >
            {{ text }}
            <template v-slot:action="{ attrs }">
              <v-btn
                color="white"
                text
                v-bind="attrs"
                @click="snackbar = false"
              >
                X
              </v-btn>
            </template>
          </v-snackbar>
        </div>
      </template>

      <template>
        <div class="text-center">
          <v-overlay :value="overlay" z-index="500">
            <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="primary"
            ></v-progress-circular>
          </v-overlay>
        </div>
      </template>

    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'
  import moment from 'moment'

  axios.defaults.baseURL = process.env.DINO.ENDPOINT;

  moment.locale('es');

  export default {
    name: 'ProductView',
    components: {
      DefaultLayout
    },
    data () {
      return {
        overlay: false,
        dialog: false,
        tab: null,
        panel: [1],
        panelOrder: [0, 2],
        // active: null,
        modal: false,
        dates: [moment().toISOString().substr(0, 10), moment().toISOString().substr(0, 10)],
        date: moment().toISOString().substr(0, 10),
        searchProduct: {
          startDate: null,
          endDate: null
        },
        search: '',
        headers: [
          { text: 'PEDIDO ID', value: 'id'},
          { text: 'FECHA DE PEDIDO', value: 'created_at' },
          { text: 'PROVEEDOR', value: 'supplier_name'},
          { text: 'FECHA DE RECOJO O DELIVERY', value: 'delivery_day' },
          { text: 'CANTIDAD PRODUCTOS', value: 'quantity' },
          { text: 'TOTAL DELIVERY', value: 'shipping_price' },
          { text: 'SUBTOTAL', value: 'subtotal' },
          { text: 'TOTAL', value: 'total' },
          { text: 'ESTADO', value: 'status' },
          { text: 'ACCIONES', value: 'actions', filterable: false, sortable: false }
        ],
        items: [],
        rules: {
          required: v => !!v || 'Por favor completar este campo'
        },
        productColorSizes: [],
        searchProduct: '',
        productCopy: [],
        select: {
          products: [],
          productColors: [],
          productColorSizes: [],
        },
        selected: {
          product: null,
          productColor: null,
          productColorSize: null,
        },
        valid: true,
        validForm: true,
        modalDeliveryDay: false,
        orderSupplier: {
          id: null,
          supplier_name: null,
          shipping_price: null,
          subtotal: null,
          total: null,
          delivery_day: null,
          quantity: null,
          status: null
        },
        quantity: null,
        unit_price: null,
        OSHeaders: [
          { text: 'PRODUCTO', value: 'product_name', width: '25%' },
          { text: 'COLOR', value: 'product_color_name', width: '10%' },
          { text: 'TALLA', value: 'product_color_size_name', width: '10%' },
          { text: 'UNI.', value: 'quantity', width: '10%' },
          { text: 'PRECIO UNI.', value: 'unit_price', width: '15%' },
          { text: 'TOTAL', value: 'amount', width: '20%' },
          { text: 'ACCIONES', value: 'accion', filterable: false, sortable: false, width: '10%' }
        ],
        OSItems: [],
        // ************ snackbar ************
        snackbar: false,
        text: '',
        color: 'green',
        // **********************************
      }
    },
    computed: {
      dateRangeText () {
        let newDate = [];
        newDate[0] = this.formatDateInit(this.dates[0]);
        newDate[1] = this.formatDateInit(this.dates[1]);

        if (newDate[1]) {
          if (this.dates[1] < this.dates[0]) {
            let newStartDateOld = newDate[1];
            let newEndDateOld = newDate[0];
            newDate[0] = newStartDateOld;
            newDate[1] = newEndDateOld;
          }
        }

        if (newDate[0] && !newDate[1]) {
          newDate[1] = newDate[0];
        }

        const [day, month, year] = newDate[0].split('/');
        const start = `${year}-${month}-${day}`;

        const [day2, month2, year2] = newDate[1].split('/');
        const end = `${year2}-${month2}-${day2}`;

        this.searchProduct.startDate = start;
        this.searchProduct.endDate = end;

        if (end) {
          if (end < start) {
            this.searchProduct.startDate = end;
            this.searchProduct.endDate = start;
          }
        }

        return newDate.join(' - ');
      },

      dateText () {
        this.orderSupplier.delivery_day = this.date;
        return this.formatDateInit(this.date);
      },

      disabledBtnSave () {
        if (!this.orderSupplier.supplier_name || !this.orderSupplier.delivery_day || !this.orderSupplier.quantity ||
          !this.orderSupplier.shipping_price || !this.orderSupplier.subtotal || !this.orderSupplier.total || this.OSItems.length == 0) {
          return true;
        }

        return false;
      }
    },
    methods: {
      showMessage(text, color) {
        this.snackbar = true;
        this.text = text;
        this.color = color;
      },

      formatDateInit (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDate: function(date) {
        return moment(date).format("DD/MM/yyyy");
      },

      formatDateTime: function(dateTime) {
        return moment(dateTime).format("DD/MM/yyyy HH:mm:ss");
      },

      getOrderSuppliers() {
        this.overlay = true;
        axios.get(process.env.DINO.PATH.GET_ORDER_SUPPLIER, {
          params: {
            startDate: this.searchProduct.startDate,
            endDate: this.searchProduct.endDate
          }
        })
        .then(response => {
          this.items = response.data;
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      getColorOrTextStatus(status, type) {
        let value = '';

        if (type === 'color') {
          if (status == 0) {
            value = 'red';
          } else if (status == 1) {
            value = 'blue';
          } else if (status == 2) {
            value = 'green';
          }
        } else if (type === 'text') {
          if (status == 0) {
            value = 'ANULADO';
          } else if (status == 1) {
            value = 'PROCESADO';
          } else if (status == 2) {
            value = 'RECEPCIONADO';
          }
        }

        return value;
      },

      searchArticulos(e) {
        if (!this.searchProduct) {
          this.select.products = this.productCopy;
        }

        this.select.products = this.productCopy.filter((product) => {
          return product.name.toLowerCase().indexOf(this.searchProduct.toLowerCase()) > -1;
        });
      },

      cleanForm() {
        this.selected.product = null;
        this.selected.productColor = null;
        this.selected.productColorSize = null;
        this.orderSupplier.id = null;
        this.orderSupplier.supplier_name = null;
        this.orderSupplier.shipping_price = null;
        this.orderSupplier.subtotal = null;
        this.orderSupplier.total = null;
        this.orderSupplier.delivery_day = null;
        this.orderSupplier.quantity = null;
        this.orderSupplier.status = null;
        this.date = moment().toISOString().substr(0, 10);
        this.OSItems = [];
        // this.$refs.form.reset();
      },

      getDetail(item) {
        this.overlay = true;
        this.orderSupplier.id = item.id;
        this.orderSupplier.supplier_name = item.supplier_name;
        this.orderSupplier.shipping_price = item.shipping_price;
        this.orderSupplier.subtotal = item.subtotal;
        this.orderSupplier.total = item.total;
        this.orderSupplier.delivery_day = item.delivery_day;
        this.orderSupplier.quantity = item.quantity;
        this.orderSupplier.status = item.status;
        this.date = item.delivery_day;
        this.OSItems = item.order_supplier_detail;
        this.dialog = true;
        this.overlay = false;
      },

      copy(item) {
        this.overlay = true;
        this.orderSupplier.id = null;
        this.orderSupplier.supplier_name = item.supplier_name;
        this.orderSupplier.shipping_price = item.shipping_price;
        this.orderSupplier.subtotal = item.subtotal;
        this.orderSupplier.total = item.total;
        this.orderSupplier.delivery_day = item.delivery_day;
        this.orderSupplier.quantity = item.quantity;
        this.orderSupplier.status = 1;
        this.date = item.delivery_day;
        this.OSItems = item.order_supplier_detail;
        this.dialog = true;
        this.overlay = false;
      },

      getProducts () {
        axios.get('/secure/products')
        .then(response => {
          this.select.products = response.data;
          this.productCopy = [...response.data];
        })
        .catch(err => {
        })
        .then(() => {
        });
      },

      getProductColors () {
        axios.get(process.env.DINO.PATH.GET_PRODUCT_COLORS.replace(':product_id', this.selected.product))
        .then(response => {
          this.select.productColors = response.data;
        })
        .catch(err => {
        })
        .then(() => {
        });
      },

      getProductColorSizes () {
        axios.get(process.env.DINO.PATH.GET_PRODUCT_COLOR_SIZES.replace(':product_id', this.selected.product))
        .then(response => {
          this.productColorSizes = response.data
        })
        .catch(err => {
        })
        .then(() => {
          if (this.select.productColors.length == 1 && this.select.productColors[0].color.name == 'NOT_COLOR') {
            this.selected.productColor = this.select.productColors[0].id;
          }
        });
      },

      addProduct () {
        let productName, productColorName, productColorSizeName = '';
        const self = this;

        this.select.products.forEach(function(obj) {
          if (obj.id == self.selected.product) {
            productName = obj.name;
            return;
          }
        });

        this.select.productColors.forEach(function(obj) {
          if (obj.id == self.selected.productColor) {
            productColorName = obj.color.name;
            return;
          }
        });

        this.select.productColorSizes.forEach(function(obj) {
          if (obj.id == self.selected.productColorSize) {
            productColorSizeName = obj.size.name;
            return;
          }
        });

        const amountForProduct = parseInt(this.quantity) * parseFloat(this.unit_price);
        this.OSItems.push({
          'product_id': this.selected.product,
          'product_color_id': this.selected.productColor,
          'product_color_size_id': this.selected.productColorSize,
          'product_name' : productName,
          'product_color_name' : productColorName,
          'product_color_size_name' : productColorSizeName,
          'quantity' : this.quantity,
          'unit_price' : this.unit_price,
          'amount' : amountForProduct.toFixed(2)
        });

        let amount = 0;
        let quantity = 0;
        this.OSItems.forEach(function(obj) {
          quantity = quantity + parseInt(obj.quantity);
          amount = parseFloat(amount) + parseFloat(obj.amount);
          amount = parseFloat(amount).toFixed(2);
        });

        this.orderSupplier.quantity = quantity;
        this.orderSupplier.subtotal = amount;
        this.orderSupplier.total = parseFloat(amount) + parseFloat(this.orderSupplier.shipping_price ? this.orderSupplier.shipping_price : 0);
        this.selected.product = null;
        this.selected.productColor = null;
        this.selected.productColorSize = null;
        this.select.productColors = [];
        this.select.productColorSizes = [];
        this.quantity = null;
        this.unit_price = null;
      },

      removeRow: function (index, item) {
        this.OSItems.splice(index, 1);
        this.orderSupplier.quantity -= parseInt(item.quantity);
        this.orderSupplier.subtotal -= item.amount;
        this.orderSupplier.total -= item.amount;
      },

      saveOrderSupplier() {
        this.overlay = true;
        axios.post(process.env.DINO.PATH.SAVE_ORDER_SUPPLIER, { 'orderSupplier': this.orderSupplier, 'orderSupplierDetail': this.OSItems })
        .then(response => {
          this.getOrderSuppliers();
          this.showMessage(response.data.message, 'green');
          this.dialog = false;
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      updateStatusOrderSupplier(orderSupplierId, status) {
        this.overlay = true;
        axios.put(process.env.DINO.PATH.UPDATE_STATUS_ORDER_SUPPLIER, { 'id': orderSupplierId, 'status': status })
        .then(response => {
          this.getOrderSuppliers();
          this.showMessage(response.data.message, 'green');
          this.dialog = false;
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

    },

    mounted: function () {
      axios.defaults.headers = {
        'authorization': localStorage.getItem('authorization')
      };

      this.getProducts();
      this.getOrderSuppliers();
    },
    watch: {
      dialog (val) {
        if (val === false) {
          this.cleanForm();
          this.tab = 'tab-1';
          this.panelOrder = [0, 2];
        }
      },
      'selected.product' (val) {
        if (val) {
          this.select.productColors = [];
          this.select.productColorSizes = [];
          this.getProductColors();
          this.getProductColorSizes();
        }
      },
      'selected.productColor' (val) {
        if (val) {
          const self = this;

          this.select.productColorSizes = [];
          this.productColorSizes.forEach(function(obj) {
            if (obj.product_color_id == val) {
              self.select.productColorSizes.push(obj);
            }
          });

          if (this.select.productColorSizes.length == 1 && this.select.productColorSizes[0].size.name == 'NOT_SIZE') {
            this.selected.productColorSize = this.select.productColorSizes[0].id;
          }
        }
      },
      'orderSupplier.shipping_price' (val) {
        if (val) {
          const subtotal = this.orderSupplier.subtotal ? this.orderSupplier.subtotal : 0;
          this.orderSupplier.total = parseFloat(subtotal) + parseFloat(val);
          this.orderSupplier.total = this.orderSupplier.total.toFixed(2)
        } else {
          this.orderSupplier.total = this.orderSupplier.subtotal;
        }
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/manage/OrderSupplier.vue